module.exports = __webpack_public_path__ + "img/paysolution.b9866517.png";